import React, { useState, useEffect, useRef } from "react";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar"
import { SBAComboBox, SBADropDown } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getPortfolioDetailAPI, getAssetLotByPortfolio, getTransactionAssetsByType, getPortfolioListAPI, getAssetShareClassddl, insertAssetLots, insertUpdateTransaction, assetDetailsUrl, CheckIfAllocationExistsAPI, transactionSaveCapitalCallAndSubAPI } from "../../../config/apiConfig";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { currencyFormatter, getTransactionByID, getPortfolioListByAssetAndTransType, gettransactionEditAccess } from "../utils";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
export const CapitalCall = () => {
    const history = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);
    const transactionId = parseInt(params.TransId) || 0;
    const objType = parseInt(params?.ObjectType);
    const [transactionData, setTransactionData] = useState(plainCapital);
    const statusStore = Gstate.transaction.statusList || [];
    const [portfolioList, setPortfolioList] = useState();
    const FromAccount = Gstate.portfolio.TOCash || [];

    const [createLot, setCreateLot] = useState(false);
    const iseditable = transactionId === 0 ? false : true;
    const [portfolio, setPortfolio] = useState();
    const [assetList, setAssetList] = useState([]);
    const [assetLots, setAssetLots] = useState([]);
    const [shareClassList, setShareClassList] = useState([]);
    const [statusDS, setStatusDS] = useState(statusStore);
    const [AddLot, setAddLot] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [transactionEditAccess, setTransactionEditAccess] = useState(false);
    const lotName = transactionData.AssetLotName;

    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const assetValue = { AssetId: transactionData.AssetId, AssetName: transactionData.AssetName };
    const selectedfromaccount = { "AssetId": transactionData.AccountIdToBalance, "AssetName": transactionData.AccountIdToBalanceName };
    const shareClassValue = { ShareClassId: transactionData.ShareclassId, ShareClassName: transactionData.ShareClassName };
    const lotValue = { AssetLotId: transactionData.AssetLotId, AssetLotName: transactionData.AssetLotName };
    const InterestExpense = transactionData.TransactionPEDetails.InterestExpense ? transactionData.TransactionPEDetails.InterestExpense : "0.00"
    const InterestIncome = transactionData.TransactionPEDetails.InterestIncome ? transactionData.TransactionPEDetails.InterestIncome : "0.00"
    const Level = objType == 1 ? [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "Capital Call",
            Routes: `${UrlPath.AssetCapitalcall}${params.AssetId}`,
        },
    ] : [
        {
            BreadCrumb: "Transactions >",
            Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
        },
        {
            BreadCrumb: "Capital Call",
            Routes: `/${UrlPath.PortfolioCapitalcall}${params.EntityId}`,
        },
    ];
    useEffect(() => {
        document.title = "Transactions Capital Call";
    }, []);

    useEffect(() => {
        setTransactionEditUserAccess();
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);


    useEffect(() => {
        if (objType == 1) {
            dispatch(getTransactionStatusAction());
            setAssetByID(params?.EntityId);
            setPortfolioByAssetId(params?.EntityId)

        } else {

            dispatch(getPortFolioListAction(null));
            dispatch(getTransactionStatusAction());
            dispatch(getPortFolioCashAccountAction(params?.EntityId));
            setPortfolioByID(params?.EntityId);

        }
        setTransactionByID(transactionId);

    }, []);
    useEffect(() => {
        if (transactionData.AssetId > 0) {
            setShareClassListbyAssetID(transactionData.AssetId);
        }
    }, [transactionData.AssetId]);

    useEffect(() => {
        if (transactionData.ShareclassId > 0) {
            setLotsByPIdAssetIdSCId(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId)
        }
    }, [transactionData.ShareclassId]);

    // Asset Fillterchange
    const AssetFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
            setAssetListByTerms(terms);
        }
    };

    // User Access Rights
    const setTransactionEditUserAccess = async () => {
        const access = await gettransactionEditAccess();
        setTransactionEditAccess(access);
    }


    //get asset By Id

    const setAssetByID = async (Id) => {
        try {
            const asset = await getAssetByID(Id);
            setTransactionData(value => ({ ...value, AssetName: asset?.AssetName, AssetId: asset?.AssetId }));
        }
        catch (e) {
            setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
            setPortfolio({});
        }
    }


    //Lots Data BY ID
    const setLotsByPIdAssetIdSCId = async (Id, assetId, shareclassId) => {

        try {
            const lots = await getAssetLotsByID(Id, assetId, shareclassId);
            if (lots.length > 0) {
                setAssetLots(lots);
                // setTransactionData(value => ({ ...value, AssetLotId: lots[0].AssetLotId, AssetLotName: lots[0].AssetLotName }))

            }
            else {
                setAddLot(true);
                setAssetLots([]);
               // setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "", IsShareBased: false }))
            }
        }
        catch (e) {
            setAssetLots([]);
            //setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "" }))
        }

    };
    const getAssetLotsByID = async (Id, assetId, shareclassId) => {
        try {
            const response = await sbaAxios({
                url: `${getAssetLotByPortfolio}${Id},${assetId},${shareclassId}`,
                method: 'get',
            });

            return response;
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
            return [];
        };
    };


    // Shareclass By AssetID

    const setShareClassListbyAssetID = async (id) => {
        try {
            const res = await getshareclassbyId(id);
            setShareClassList(res);
            //setTransactionData(value => ({ ...value, ShareclassId: res[0].ShareclassId, ShareClassName: res[0].ShareClassName}));
        }
        catch (e) {
            setShareClassList([]);
            setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
        }
    };
    const getshareclassbyId = async (AssetId) => {
        try {
            const response = await sbaAxios({
                url: `${getAssetShareClassddl}${AssetId},${'true'}`,
                method: 'get',
            });
            return response;
        }
        catch (e) {
            return [];
        };
    };
    //Asset by term
    const setAssetListByTerms = async (term) => {
        try {
            const assetList = await getAssetListByTerm(term);
            setAssetList(assetList);
        }
        catch (e) {
            console.log(e, 'Error Fetching the asset List');
            setAssetList([]);
        }
    }
    const getAssetListByTerm = async (term) => {
        try {
            const resposne = await sbaAxios({ url: `${getTransactionAssetsByType}?transTypeId=24&searchString=${term}` })
            return resposne;
        }
        catch (e) {
            return []
        };
    };


    //set portfolio data

    const setPortfolioByID = async (Id) => {


        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };
    const setPortfolioByAssetId = async (Id) => {

        try {
            const portfolio = await getPortfolioListByAssetAndTransType(Id, 14);
            const portfolios = portfolio.map((item) => ({
                'PortfolioName': item.Name,
                'PortfolioId': item.PortfolioId
            }))
            setPortfolioList([]);
            if (portfolios.length > 0) {

                // setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
                //setPortfolioByID(portfolios[0].PortfolioId);
            }
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolioList({});
        }
    }

    // Get Transcation Details
    const setTransactionByID = async (id) => {
        if (id > 0) {
            try {
                const details = await getTransactionByID(id);
                const loadFee = details?.ChildDetails?.find(item => item.TransTypeId === 22)?.TransAmount || 0;
                setTransactionData(details);
                setPortfolioByID(details?.PortfolioId)
                setTransactionData(value => ({ ...value, LoadFee: loadFee ? loadFee : 0, TotalAmount: Math.abs(details.TransAmount + loadFee), LocalLoadFee: Math.abs(loadFee) * details.ExchangeRate, TotalLocalAmount: Math.abs(details.LocalAmount) + (Math.abs(loadFee * details.ExchangeRate)) }));

            } catch (e) {
                setTransactionData(plainCapital);
            }
        }
        else {
            setTransactionData(plainCapital);
        }

    };


    //Onchange events

    const fromaccountChange = (e) => {
        if (e.value) {
            setTransactionData(value => ({
                ...value,
                AccountIdToBalance: e.value.AssetId,
                AccountIdToBalanceName: e.value.AssetName
            }));
        } else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }
        //  setTransactionData(value => ({ ...value, AccountIdToBalance: e.value.AssetId, AccountIdToBalanceName: e.value.AssetName }));

    }
    const portfolioDDChng = (e) => {

        if (e.value) {

            const portfolio = e.value;
            setPortfolioByID(e.value.PortfolioId);
            dispatch(getPortFolioCashAccountAction(e.value.PortfolioId));
            if (objType == 3) {
                history(`/${UrlPath.PortfolioCapitalcall}${transactionId}/${e.value.PortfolioId}/3`);
                setTransactionData((prevData) => ({ ...prevData, AssetId: 0, AssetName: '', AssetLotId: 0, AssetLotName: '', ShareclassId: 0, ShareClassName: '', TransAmount: 0, LocalAmount: 0, ExchangeRate: "1.00", LoadFee: 0, LocalLoadFee: 0, TotalAmount: 0, TotalLocalAmount: 0 }));

            }
            else {
                setTransactionData((prevData) => ({ ...prevData, AssetLotId: 0, AssetLotName: '', ShareclassId: 0, ShareClassName: '', TransAmount: 0, LocalAmount: 0, ExchangeRate: "1.00", LoadFee: 0, LocalLoadFee: 0, TotalAmount: 0, TotalLocalAmount: 0 }));

            }
        }
        else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }

    };
    const portfolioFilterChange = (e) => {

        const terms = e.filter.value;
        if (terms.length > 1) {
            setPortfolioByTerm(terms);
        }
    };
    const setPortfolioByTerm = async (term) => {
        try {
            const portfolioList = await getPortfolioListByTerms(term);
            setPortfolioList(portfolioList);
        }
        catch (e) {
            console.log(e, 'Error Fetching the data for portfolio');
            setPortfolioList([]);
        }
    };
    const getPortfolioListByTerms = async (term) => {
        try {
            const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
            return response;
        }
        catch (e) {
            return [];
        }
    };
    const statusDDChng = (e) => {

        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }


    };
    const CheckAllocationStatus = async (pID, aID, scID, Date,alID) => {
        try {
            const url = `${CheckIfAllocationExistsAPI}${pID},${aID},${scID},${transactionData.TransTypeId},${Date},${alID}`
            const res = await sbaAxios({ url })
            if (res)
                SBNotify({ Msg: "A capital call already exists on the selected date for current portfolio/asset/ShareClass combination", type: 'error' });
        } catch (error) {

        }
    }
    const transdateChange = (e) => {
        const value = moment(e).format("MM-DD-yyyy");
        const assetLotId = transactionData?.AssetLotId || 0;
        const assetLotName = transactionData.ShareClassName ? `${transactionData.ShareClassName} - ${moment(e).format("MM/DD/yyyy")}` : "";
        CheckAllocationStatus(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, e.toISOString(), assetLotId);
        setTransactionData((prevData) => ({ ...prevData, ["TransDate"]: value, AssetLotName: assetLotName }));

    }
    const AssetChng = (e) => {

        if (e.value) {
            const asset = e.value;
            if (objType == 1) {
                setPortfolioByAssetId(e.value.AssetId);
            }
            setTransactionData(pv => ({ ...pv, AssetId: asset.AssetId, AssetName: asset.AssetName, ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' }));
            setAssetLots([]);
            setLotsByPIdAssetIdSCId(transactionData.PortfolioId, asset.AssetId, transactionData.ShareclassId)
        }
        else {
            // Handle null or undefined value
            console.error("Invalid value:", e.value);
        }
    };

    const ShareClassChng = (e) => {
        if (e.value) {
            const shareClass = e.value;
 

            const assetLotName = `${shareClass.ShareClassName} - ${moment(transactionData.TransDate).format("MM/DD/yyyy")}`;
            setTransactionData(pv => ({ ...pv, ShareclassId: shareClass.ShareClassId, ShareClassName: shareClass.ShareClassName, AssetLotName: assetLotName }));

            setLotsByPIdAssetIdSCId(transactionData.PortfolioId, transactionData.AssetId, shareClass.ShareClassId)
            const dateValue = convertToISO(transactionData?.TransDate);
            const assetLotId=transactionData?.AssetLotId || 0;
            CheckAllocationStatus(transactionData.PortfolioId, transactionData.AssetId, shareClass.ShareClassId, dateValue ,assetLotId);
        }
    };
    const AssetLotChng = (e) => {
        if (e.value) {
            const lot = e.value;
            setTransactionData(pv => ({ ...pv, AssetLotId: lot.AssetLotId, AssetLotName: lot.AssetLotName }));
        }
    };
    // lot creation 
    const updateAssetLotAfterInsert = (lotId, list) => {
        const lot = list.find(item => item.AssetLotId == lotId);
        setTransactionData(value => ({ ...value, AssetLotId: lot.AssetLotId, AssetLotName: lot.AssetLotName }))
    }
    const saveAssetLot = (allocationDate, transactionDate, isShareBase) => {
        const LotsDS = {
            "PortfolioId": transactionData.PortfolioId,
            "AssetId": transactionData.AssetId,
            "ShareClassId": transactionData.ShareclassId,
            "IsShareBased": isShareBase,
            "InitAllocationDate": allocationDate,
            "TransactionDate": transactionDate,
        };
        sbaAxios({
            url: `${insertAssetLots}`,
            method: "post",
            data: LotsDS,
        })
            .then(async (response) => {
                if (response) {
                    SBNotify({
                        type: "success",
                        Msg: "Lots Added Successfully",
                    });
                    const res = await getAssetLotsByID(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId);
                    setCreateLot(false);
                    setAssetLots(res)
                    updateAssetLotAfterInsert(response, res);

                } else {
                    SBNotify({
                        type: "error",
                        Msg: `Failed to Update`,
                    });
                }
            })
            .catch(() => { });
    };
    const openCreatAssetLot = () => {
        if (transactionId === 0) {
            if (!transactionData.PortfolioId) {
                SBNotify({ Msg: "Please Select Portfolio", type: "error" });
            }
            else if (!transactionData.AssetId) {
                SBNotify({ Msg: "Please Select Asset", type: "error" });
            }
            else if (!transactionData.ShareclassId) {
                SBNotify({ Msg: "Please Select ShareClass", type: "error" });
            }
            else {
                setCreateLot(true)
            }
        }

    };

    const SaveCapitalcall = () => {

        let saveSuccess = true;

        const Childdata = {
            "transId": 0,
            "assetId": 7,
            "transTypeId": 22,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.LoadFee,
            "localAmount": 0,
            "transDescription": "",
        }
        const EditChildData = transactionData.ChildDetails.map((item, index) => {
            if (item.TransTypeId === 22) {
                item.TransAmount = transactionData.LoadFee > 0 ? transactionData.LoadFee : 0;
            }
            return item;
        });

        const foundRecord = EditChildData.some(item => item.TransTypeId === 22);
        if (!foundRecord) {
            EditChildData.push({
                transId: 0,
                assetId: 7,
                transTypeId: 22,
                transDate: transactionData.TransDate,
                transAmount: transactionData.LoadFee,
                localAmount: 0,
                transDescription: ""
            });
        }

        const savedata = {

            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": transactionData.AssetId,
            "shareClassId": transactionData.ShareclassId,
            "assetLotId": transactionData?.AssetLotId || 0,
            "accountIdToBalance": transactionData.AccountIdToBalance,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": 24,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "InitialAllocationDate": transactionData.TransDate,
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
            "isFullRedemption": false,
            "isInsurance": false,
            "isFee": false,
            "isCommitmentRelease": false,
            "modifiedBy": 0,
            "transactionPEDetails":
            {
                "peTransId": 22,
                "isRecallable": false,
                "isImpactCommitment": transactionData.TransactionPEDetails.IsImpactCommitment,
                "recallableAmount": 0,
                "recallablePercent": 0,
                "interestIncome": transactionData.TransactionPEDetails.InterestIncome,
                "interestExpense": transactionData.TransactionPEDetails.InterestExpense
            },
            "childTrans": transactionId === 0 ? [Childdata] : EditChildData
        }

        if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === 0) {
            SBNotify({ Msg: "From Account is Required", type: "error" });
            saveSuccess = false;
        }
        // else if (!transactionData.AssetLotId || transactionData.AssetLotId === 0) {
        //     SBNotify({ Msg: "Please Create Lot", type: "error" });
        //     saveSuccess = false;
        // }
        else if (!transactionData.ShareclassId || transactionData.ShareclassId === 0) {
            SBNotify({ Msg: "Shareclass is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetId || transactionData.AssetId === 0) {
            SBNotify({ Msg: "Asset is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.TransAmount || transactionData.TransAmount === 0) {

            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }

        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateTransaction}`,
                method: "post",
                data: savedata,
            })
                .then((response) => {
                    if (response==-1) {
                        SBNotify({ Msg: "A capital call already exists on the selected date for current portfolio/asset/ShareClass combination", type: 'error' });
                    }
                    else{
                        SBNotify({
                            type: "success",
                            Msg: "Capital Call Saved Successfully",
                        });
                        navigateBack();

                    } 
                    // else {
                    //     SBNotify({
                    //         type: "error",
                    //         Msg: `Failed to Update`,
                    //     });
                    // }
                })
                .catch(() => { });
        }


    }
    const SaveCapitalcallLastest = () => {

        let saveSuccess = true;

        const Childdata = {
            "transId": 0,
            "assetId": 7,
            "transTypeId": 22,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.LoadFee,
            "localAmount": 0,
            "transDescription": "",
            "transPercentage": 0,
            "shares": 0,
        };
        const EditChildData = transactionData.ChildDetails.map((item, index) => {
            if (item.TransTypeId === 22) {
                item.TransAmount = transactionData.LoadFee > 0 ? transactionData.LoadFee : 0;
            }
            return item;
        });

        const foundRecord = EditChildData.some(item => item.TransTypeId === 22);
        if (!foundRecord) {
            EditChildData.push({
                transId: 0,
                assetId: 7,
                transTypeId: 22,
                transDate: transactionData.TransDate,
                transAmount: transactionData.LoadFee,
                localAmount: 0,
                transDescription: "",
                transPercentage: 0,
                shares: 0,
            });
        }
        const saveData1 = {
            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": transactionData.AssetId,
            "shareClassId": transactionData.ShareclassId,
            "assetLotId": transactionData?.AssetLotId || 0,
            "accountIdToBalance": transactionData.AccountIdToBalance,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": 24,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "transPercentage": 0, //1
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "allocationDate": transactionData.TransDate,  //1
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
            "initialAllocationDate": transactionData.TransDate,
            "isFullRedemption": false,
            "partialRedemptionModeId": 0, //1
            "isInsurance": false,
            "isFee": false,
            "isShareBased": false, //1
            "isCommitmentRelease": false,
            "refTransAssetLotId": 0, //1
            "modifiedBy": 0,
            "transactionPEDetails": {
                "peTransDetailID": 22,  //chnage
                "isRecallable": false,
                "isImpactCommitment": transactionData.TransactionPEDetails.IsImpactCommitment,
                "recallableAmount": 0,
                "recallablePercent": 0,
                "interestIncome": transactionData.TransactionPEDetails.InterestIncome,
                "interestExpense": transactionData.TransactionPEDetails.InterestExpense
            },
            "childTrans": transactionId === 0 ? [Childdata] : EditChildData
        };

        if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === 0) {
            SBNotify({ Msg: "From Account is Required", type: "error" });
            saveSuccess = false;
        }
        // else if (!transactionData.AssetLotId || transactionData.AssetLotId === 0) {
        //     SBNotify({ Msg: "Please Create Lot", type: "error" });
        //     saveSuccess = false;
        // }
        else if (!transactionData.ShareclassId || transactionData.ShareclassId === 0) {
            SBNotify({ Msg: "Shareclass is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.AssetId || transactionData.AssetId === 0) {
            SBNotify({ Msg: "Asset is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.TransAmount || transactionData.TransAmount === 0) {

            SBNotify({ Msg: "Please Enter Amount", type: "error" });
            saveSuccess = false;
        }

        if (saveSuccess) {
            sbaAxios({
                url: `${transactionSaveCapitalCallAndSubAPI}`,
                method: "post",
                data: saveData1,
            })
                .then((response) => {
 
                    if (response==-1) {
                        SBNotify({ Msg: "A capital call already exists on the selected date for current portfolio/asset/ShareClass combination", type: 'error' });
                    }
                    else{
                        SBNotify({
                            type: "success",
                            Msg: "Capital Call Saved Successfully",
                        });
                        navigateBack();

                    } 
                })
                .catch(() => { });
        }


    }
    const handleClick = () => {
        setShowModal(true);
    };



    const exchangeRateChange = (e) => {
        const parsedValue = parseFloat(e);
        setTransactionData(value => ({
            ...value,
            ExchangeRate: parsedValue,
            LocalAmount: Math.abs(transactionData?.TransAmount) * parsedValue,
            LocalLoadFee: value.LoadFee * parsedValue,
            TotalLocalAmount: Math.abs(transactionData?.TransAmount * parsedValue) + (Math.abs(value.LoadFee) * parsedValue)
        }));
    }
    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${transactionData.AssetId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };

    const isEditable = true; // or false, depending on your logic

    const handleDateChange = (e) => {
        if (e) {
            const value = e.toISOString();
            setTransactionData((prevData) => ({ ...prevData, InitialAllocationDate: value }));
        }
    };
    //const handleDateChange = (newDate) => {

    //    setInitialAllocationDate(newDate);
    //};
    return <>
        <TopBar label={"Capital Call"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="asset-detail-screen p-3">
                <div className="detail p-4">
                    <div className="col-lg-12 px-0">
                        <div className="row m-0">

                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                    <div>
                                        <SBADropDown
                                            className="w-75"
                                            data={statusDS}
                                            textField={"TransStatus"}
                                            valueField={"TransStatusId"}
                                            value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                            onChange={statusDDChng}

                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={portfolioList}
                                            textField={"PortfolioName"}
                                            valueField={"PortfolioId"}
                                            onChange={portfolioDDChng}
                                            onFilterChange={portfolioFilterChange}
                                            value={portfolioVal}
                                            disabled={iseditable}
                                        />
                                    </div>

                                </div>

                            </div>

                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">From Account<span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={FromAccount}
                                            textField={"AssetName"}
                                            valueField={"AssetId"}
                                            onChange={fromaccountChange}
                                            value={selectedfromaccount}

                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-1 label">Asset <span class="mandatory">*</span></label>
                                    <div>
                                        <SBAComboBox
                                            className="w-75"
                                            data={assetList}
                                            textField={"AssetName"}
                                            valueField={"AssetId"}
                                            value={assetValue}
                                            onChange={(e) => AssetChng(e)}
                                            onFilterChange={AssetFilterChange}
                                            disabled={iseditable}

                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="row mb-4">

                                <div className="col-md-4">
                                    <label className="mb-1 label">Share Class<span class="mandatory">*</span></label>
                                    <div>
                                        <SBADropDown
                                            className="w-75"
                                            data={shareClassList}
                                            textField={"ShareClassName"}
                                            valueField={"ShareClassId"}
                                            value={shareClassValue}
                                            onChange={(e) => ShareClassChng(e)}
                                            disabled={iseditable}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label className="mb-1 label">Lot</label>
                                    <div>
                                        {/* <SBAComboBox
                                            className="w-75"
                                            data={assetLots}
                                            textField={"AssetLotName"}
                                            valueField={"AssetLotId"}
                                            value={lotValue}
                                            onChange={(e) => AssetLotChng(e)}
                                            disabled={true}
                                        /> */}
                                        <input type="text" className="form-control w-75" value={lotName} disabled />
                                    </div>
                                </div>

                            </div>

                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <div>
                                        <label className="mb-1 mt-2 label"></label> </div>
                                    <label className="mb-1 label">Transaction Date</label>
                                    <span class="mandatory">*</span>
                                    <div className="d-flex gap-2">
                                        <SBDatePicker
                                            className="w-75"
                                            value={moment(transactionData.TransDate)}
                                            onChange={(e) => transdateChange(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <Link className="noUnderLine" onClick={handleClick}>USD</Link> </div>
                                    <label className="mb-1 label">Amount<span class="mandatory">*</span></label>
                                    <div className="d-flex gap-2">

                                        <SBACurrencyInput
                                            className={"form-control w-75"}

                                            decimalsLimit={2}
                                            value={transactionData?.TransAmount ? Math.abs(transactionData?.TransAmount) : '0.00'}
                                            onBlur={(e) => {
                                                const parsedValue = parseFloat(e);
                                                setTransactionData(value => ({
                                                    ...value,
                                                    TransAmount: parsedValue,
                                                    LocalAmount: transactionData?.ExchangeRate * parsedValue,
                                                    TotalLocalAmount: transactionData?.ExchangeRate * parsedValue - transactionData.LocalLoadFee,
                                                    TotalAmount: parsedValue - value.LoadFee
                                                }));
                                            }}
                                            disableGroupSeparators={false}
                                        />

                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <label className="mb-1 mt-2 label"><Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{ marginLeft: '8px' }}>({currencyFormatter(transactionData.ExchangeRate, 2)})</span></label> </div>
                                    <label className="mb-1 label">Local Amount</label>
                                    <div className="d-flex gap-2">
                                        <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(Math.abs(transactionData.LocalAmount), 2)} />

                                    </div>
                                </div>


                            </div>

                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">Initial Allocation Date</label>
                                    <div className="d-flex gap-2">
                                        <SBDatePicker
                                            className="w-75"
                                            value={moment(transactionData.TransDate)}
                                            onChange={handleDateChange}
                                            disabled={iseditable}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label className="mb-1 label">Fees   </label>
                                    <div className="d-flex gap-2">
                                        <SBACurrencyInput
                                            className="w-75"
                                            decimalsLimit={2}
                                            value={Math.abs(transactionData?.LoadFee) ? transactionData?.LoadFee : '0'}
                                            onBlur={(e) => {
                                                const parsedValue = parseFloat(e);
                                                setTransactionData(value => ({
                                                    ...value,
                                                    LoadFee: parsedValue,
                                                    LocalLoadFee: parsedValue * transactionData.ExchangeRate,
                                                    TotalAmount: Math.abs(transactionData.TransAmount) + parsedValue,
                                                    TotalLocalAmount: (Math.abs(transactionData.LocalAmount)) + (parsedValue * transactionData.ExchangeRate),
                                                }));
                                            }}
                                            disableGroupSeparators={false}
                                        />

                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <label className="mb-1 label">Fees</label>
                                    <div className="d-flex gap-2">
                                        <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(transactionData.LocalLoadFee, 2)} />

                                    </div>
                                </div>

                            </div>

                            <div className="row mb-4">

                                <div className="col-md-4">
                                    <label className="mb-1 label">
                                        <input
                                            type="checkbox"
                                            checked={transactionData?.TransactionPEDetails.IsImpactCommitment}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setTransactionData(prevData => ({
                                                    ...prevData,
                                                    TransactionPEDetails: {
                                                        ...prevData.TransactionPEDetails,
                                                        IsImpactCommitment: isChecked
                                                    }
                                                }));
                                            }}
                                        /> Impact Commitment</label>
                                </div>

                                <div className="col-md-4">
                                    <label className="mb-1 label">Total  Amount</label>
                                    <div className="d-flex gap-2">
                                        <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(Math.abs(transactionData.TotalAmount), 2)} />

                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <label className="mb-1 label"> Total Local Amount</label>
                                    <div className="d-flex gap-2">
                                        <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(Math.abs(transactionData.TotalLocalAmount), 2)} />

                                    </div>
                                </div>
                            </div>
                            <div className="row mb-4">

                                <div className="col-md-4">
                                    <label className="mb-1 label">Interest Income</label>
                                    <div>
                                        <SBACurrencyInput
                                            className={"form-control w-75"}

                                            decimalsLimit={2}
                                            value={InterestIncome}
                                            onBlur={(e) => {
                                                const parsedValue = parseFloat(e);
                                                setTransactionData(prevData => ({
                                                    ...prevData,
                                                    TransactionPEDetails: {
                                                        ...prevData.TransactionPEDetails,
                                                        InterestIncome: parsedValue
                                                    }
                                                }));
                                            }}
                                            disableGroupSeparators={false}
                                        />

                                    </div>
                                </div>

                            </div>
                            <div className="row mb-4">
                                <div className="col-md-4">
                                    <label className="mb-1 label">Interest Expense</label>
                                    <div>
                                        <SBACurrencyInput
                                            className={"form-control w-75"}

                                            decimalsLimit={2}
                                            value={InterestExpense}
                                            onBlur={(e) => {
                                                const parsedValue = parseFloat(e);
                                                setTransactionData(prevData => ({
                                                    ...prevData,
                                                    TransactionPEDetails: {
                                                        ...prevData.TransactionPEDetails,
                                                        InterestExpense: parsedValue
                                                    }
                                                }));
                                            }}
                                            disableGroupSeparators={false}
                                        />



                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row m-0">
                            <div className="col-md-8 mb-4">
                                <label className="mb-1 label">Description</label>
                                <textarea
                                    style={{ height: '100px', width: "138%", }}
                                    className="form-control"
                                    type="text"
                                    name="TransDescription"
                                    value={transactionData?.TransDescription}
                                    onChange={(e) => { setTransactionData(value => ({ ...value, TransDescription: e.target.value })) }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="m-3 d-flex justify-content-end"

                        style={{ paddingBottom: "15px", paddingRight: "128px" }}
                    >
                        <button className="s-sm-btn" onClick={navigateBack}>
                            Cancel
                        </button>
                        {transactionId !== 0 ? (
                            <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={SaveCapitalcallLastest}>
                                Save
                            </button>
                        ) : (
                            <button className="ms-2 p-sm-btn" disabled={false} onClick={SaveCapitalcallLastest}>
                                Save
                            </button>
                        )}




                    </div>
                </div>

            </div>
            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={() => { setShowModal(false) }} onBlur={(e) => exchangeRateChange(e)}></ExchangeRateModal>
            <CreateAssetLot open={createLot} setOpen={setCreateLot} saveLot={saveAssetLot} />

            <ToastContainer />
        </div></>
};
const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};

const getAssetByID = async (AssetID) => {
    try {
        const response = await sbaAxios({ url: assetDetailsUrl + AssetID });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the Asset details')
        return {};
    };
};

var transdate = new Date();
var TransactionDate = new Date(transdate.getFullYear(), transdate.getMonth() + 1, 1);
const plainCapital = {
    "TransId": 0,
    "TransTypeId": 24,
    "TransTypeName": "CapitalCall",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AssetLotName": "",
    "AccountIdToBalance": 1,
    "AccountIdToBalanceName": "CASH",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": TransactionDate,
    "TransAmount": 0,
    "TransPercentage": 0,
    "LocalAmount": 0,
    "Shares": 0,
    "NAV": 0,
    "NoofShares": 0,
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": "1.00",
    "TotalRedemptionAmount": "",
    "RedemptionFee": 0,
    "TotalPosition": 100,
    "IsFullRedemption": false,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "IsFIFO": false,
    "LoadFee": 0,
    "LocalLoadFee": 0,
    "TotalAmount": 0,
    "TotalLocalAmount": 0,
    "InitialAllocationDate": TransactionDate,
    "TransactionPEDetails": {
        "PETransDetailID": 1,
        "IsRecallable": false,
        "IsImpactCommitment": false,
        "RecallableAmount": 0.00,
        "RecallablePercent": 0.00,
        "InterestIncome": 0.00,
        "InterestExpense": 0.00,
    },
    "ChildDetails": [{
        "AssetId": 0,
        "AssetLotId": 0,
        "AssetLotName": "",
        "AssetName": "",
        "InitialAllocationDate": TransactionDate.InitialAllocationDate,
        "ModifiedById": 0,
        "ModifiedByName": "",
        "NrOfShares": 0,
        "ShareClassName": "",
        "ShareclassId": 0,
        "TotalNrOfShares": 0,
        "TotalPosition": 0,
        "TransAmount": 0,
        "TransDate": TransactionDate,
        "TransDescription": "",
        "TransId": 22,
        "TransPercentage": 0,
        "TransTypeId": 5,
        "TransTypeName": "CapitalCall",
        "AvailableCashAmount": 0,

    }
    ]
}

const CreateAssetLot = ({ open, setOpen, saveLot }) => {
    const [lotAllocationDate, setLotAllocationDate] = useState(TransactionDate);
    const [lotTransactionDate, setLotTransactionDate] = useState(TransactionDate);
    const [isShareBased, setIsShareBased] = useState(false);
    const updateDate = (e, setter) => {
        if (e) {
            const updatedDate = e.toISOString();
            setter(updatedDate);
        }
    }
    return <SBADrawer open={open} setOpen={setOpen} close={false} title={'Create Asset Lot'}>
        <div>
            <label className="header-container m-1"><b>Init Allocation Date</b></label>
            <div>
                <SBDatePicker
                    popupSettings={{ className: 'modalDD' }}
                    className="w-75"
                    value={moment(lotAllocationDate)}
                    onChange={(e) => { updateDate(e, setLotAllocationDate) }}>
                </SBDatePicker>
            </div>
            <br></br>
            <label className="header-container m-1"><b>Transaction Date </b></label>
            <div>
                <SBDatePicker popupSettings={{ className: 'modalDD' }} className="w-75" value={moment(lotTransactionDate)} onChange={(e) => { updateDate(e, setLotTransactionDate) }}>
                </SBDatePicker>
            </div>
            <br></br>
            <div className="mb-4">
                <label className="mb-1 label">  <input type="checkbox" checked={isShareBased} onChange={(e) => { setIsShareBased(e.target.checked) }} /> Is Share Based</label>
            </div>
            <div className="mt-4">
                <button className="s-sm-btn mx-1" onClick={() => setOpen(false)}>
                    Cancel
                </button>
                <button className="p-sm-btn mx-1" onClick={() => { saveLot(lotAllocationDate, lotTransactionDate, isShareBased) }}>
                    Save
                </button>

            </div>
        </div>
    </SBADrawer>
};



function convertToISO(input) {
    let dateMoment;
  
    if (moment.isMoment(input)) {
        dateMoment = input;
    } else if (typeof input === 'string') {
        dateMoment = moment(input, "DD-MM-YYYY", true);
        
        if (!dateMoment.isValid()) {
            dateMoment = moment(input);
        }
    } else if (input instanceof Date) {
        dateMoment = moment(input);
    } else {
        throw new Error("Unsupported input format");
    }
    if (!dateMoment.isValid()) {
        throw new Error("Invalid date format");
    }
  
    return dateMoment.toISOString();
  }